import React, { Component, Fragment } from "react";
import Button from "../../../components/atoms/Button";
import LabelWithInput from "../../../components/molecules/LabelWithInput";
import SelectFiles from "../../../components/atoms/SelectFiles";
import TextBox from "../../../components/atoms/TextBox";
import CheckBox from "../../../components/atoms/CheckBox";

export class DataKeuangan extends Component {
	_isMounted = false;
	constructor(props) {
		super(props);
		this.state = {
			laporan_laba_rugi: { id: "income-statement", loading: false, file: { name: "", value: "", done: false, loading: false, url: "" }, data: { name: "parameters", value: {} } },
			laporan_keuangan: { id: "financial-statement", loading: false, file: { name: "", value: "", done: false, loading: false, url: "" } },
			disclaimerFlag: { text: "Saya menyatakan bahwa data yang telah saya isi di atas adalah valid.", value: true, checked: false },
			tncFlag: { text: "Dengan mengisi formulir ini, saya menyatakan kepada pihak platform berhak melakukan validasi data.", value: true, checked: false },
		};
	}
	updateState = (name, value, id) => {
		let files = this.state[id];
		files.data.value[name] = value;
		if (files.file.url) {
			files.file.url = "";
		}
		if (this._isMounted) {
			this.setState({ [id]: files });
		}
	};
	uploadFile = (name, value, id) => {
		let files = this.state[id];
		// console.log({name, value : value, id});
		files.file.name = "file";
		files.file.value = value;
		files.file.done = "1 File Selected";
		if (this._isMounted) {
			this.setState({ [id]: files });
		}
	};
	componentWillUnmount = () => {
		this._isMounted = false;
	};
	componentDidMount = () => {
		this._isMounted = true;
		if (this._isMounted) {
			this.setData();
		}
	};
	setData = () => {
		const { profileState, setStateFinanceDocs } = this.props;
		let { laporan_laba_rugi, laporan_keuangan } = this.state;
		const { documents } = profileState.list.customerInfo.corporate;
		for (let i = 0; i < documents.length; i++) {
			setStateFinanceDocs(documents[i].documentType, true);
			if (documents[i].documentType === "LR0") {
				laporan_laba_rugi.data.value = { documentNumber: documents[i].documentNumber };
				laporan_laba_rugi.file.url = documents[i].documentFileUrl;
				this.setState({ laporan_laba_rugi });
			}
			if (documents[i].documentType === "LKU") {
				laporan_keuangan.file.url = documents[i].documentFileUrl;
				this.setState({ laporan_keuangan });
			}
		}
		// console.log({akta_badan_usaha, akta_perubahan});

		// <p>{JSON.stringify(profileState.list.customerInfo.corporate.documents)}</p>
	};
	uploadLR = () => {
		let { UploadCompanyDocs, SetError } = this.props;
		let dataUpload = this.state.laporan_laba_rugi;
		// console.log("apemih === ",dataUpload)

		if (!dataUpload.file.value) {
			SetError("Upload file terlebih dahulu");
		} else {
			dataUpload.loading = true;
			this.setState({ laporan_laba_rugi: dataUpload });
			let { file, data } = dataUpload;
			console.log("mau tau apa", { file, data });
			let sendData = [];
			let formData = new FormData();
			formData.append(file.name, file.value);
			// formData.append(data.name, JSON.stringify(data.value));
			UploadCompanyDocs(dataUpload.id, formData, "laporan_laba_rugi", this.loadingDone);
		}
	};
	uploadKeungan = () => {
		let { UploadCompanyDocs, SetError } = this.props;
		let dataUpload = this.state.laporan_keuangan;
		// console.log("apemih === ",dataUpload)

		if (!dataUpload.file.value) {
			SetError("Upload file terlebih dahulu");
		} else {
			dataUpload.loading = true;
			this.setState({ laporan_keuangan: dataUpload });
			let { file, data } = dataUpload;
			console.log("mau tau apa", { file, data });
			let sendData = [];
			let formData = new FormData();
			formData.append(file.name, file.value);
			UploadCompanyDocs(dataUpload.id, formData, "laporan_keuangan", this.loadingDone);
		}
	};
	loadingDone = (id) => {
		let dataUpload = this.state[id];
		dataUpload.loading = false;
		dataUpload.file.done = false;
		if (this._isMounted) {
			this.setState({ [id]: dataUpload });
			this.setData();
		}
	};
	disclaimerFlagChecked = () => {
		let { disclaimerFlag, tncFlag } = this.state;
		disclaimerFlag.checked = !disclaimerFlag.checked;
		this.setState({ disclaimerFlag });
	};
	tncFlagChecked = () => {
		let { disclaimerFlag, tncFlag } = this.state;
		tncFlag.checked = !tncFlag.checked;
		this.setState({ tncFlag });
	};
	submitLP = () => {
		let { disclaimerFlag, tncFlag } = this.state;
		let data = { disclaimerFlag: disclaimerFlag.checked, tncFlag: tncFlag.checked };
		this.props.submitLP(data);
		console.log(data);
	};
	render() {
		const { col, changeStep, profileState, submit } = this.props;
		const { laporan_keuangan, laporan_laba_rugi, disclaimerFlag, tncFlag } = this.state;
		return (
			<Fragment>
				{/* <p>{JSON.stringify(profileState.list.customerInfo.corporate.documents)}</p> */}

				{/* <LabelWithInput label='No. Laporan Laba Rugi' col={col} {...this.props} note = {null}>
                    <TextBox name='laba_rugi' value={laporan_laba_rugi.data.value.documentNumber || ''} onChange={(e)=> this.updateState('documentNumber',  e.target.value, 'laporan_laba_rugi')}/>
                </LabelWithInput> */}
				<LabelWithInput label="Laporan Laba Rugi" col={col} {...this.props} info="File berformat PDF, JPG, JPEG, PNG dengan ukuran maks. 10 MB">
					<SelectFiles
						name="laba_rugi"
						extention=".pdf,.png,.jpg,.jpeg"
						files={laporan_laba_rugi.file.url}
						onChange={(name, value) => {
							this.uploadFile(name, value, "laporan_laba_rugi");
						}}
						loading={laporan_laba_rugi.file.loading}
						done={laporan_laba_rugi.file.done}
						error={null}
					/>
				</LabelWithInput>
				<LabelWithInput label="" col={col} {...this.props}>
					<Button width="small" color="blue" title="Simpan" loading={laporan_laba_rugi.loading} onClick={this.uploadLR} />
				</LabelWithInput>

				<hr className="border-dashed add-margin" />

				<LabelWithInput label="Unggah Laporan Keuangan per Semester" col={col} {...this.props} info="File berformat PDF, JPG, JPEG, PNG dengan ukuran maks. 10 MB">
					<SelectFiles
						name="laporan_keuangan"
						extention=".pdf,.png,.jpg,.jpeg"
						files={laporan_keuangan.file.url}
						onChange={(name, value) => {
							this.uploadFile(name, value, "laporan_keuangan");
						}}
						loading={laporan_keuangan.file.loading}
						done={laporan_keuangan.file.done}
						error={null}
					/>
				</LabelWithInput>
				<LabelWithInput label="" col={col} {...this.props}>
					<Button width="small" color="blue" title="Simpan" loading={laporan_keuangan.loading} onClick={this.uploadKeungan} />
				</LabelWithInput>
				<CheckBox className="pb-3" onChange={(e) => this.disclaimerFlagChecked()} name="agreement_LP" data={[disclaimerFlag]} />
				<CheckBox name="agreement_LP" onChange={(e) => this.tncFlagChecked()} data={[tncFlag]} />

				<div className="bg-button add-margin">
					<Button onClick={() => submit(3)} width="big" color="outline" title="Sebelumnya" />
					{disclaimerFlag.checked && tncFlag.checked ? <Button onClick={this.submitLP} width="big" color="blue" title="Simpan" /> : <Button isDisabled width="big" color="blue" title="Simpan" />}
				</div>
			</Fragment>
		);
	}
}

export default DataKeuangan;
